// extracted by mini-css-extract-plugin
export var falconContainer = "_vm-2";
export var offerCenter = "_vm-0";
export var roktContainer = "_vm-1";